(function () {
    angular.module('rightPaneModule').directive("assignedLessonItem", function () {
        return {
            restrict: "E",
            scope: {
                assignedLessonData: '=',
                currentStandard: '='
            },
            templateUrl: '/resources/right-pane/partials/assigned-lesson-item.html',
            controller: [
                '$rootScope',
                '$scope',
                'assignedFocusApi',
                'cancelableResourceManager',
                '$modal',
                'minutesFilter',
                '$state',
                '$window',
                'compareDay',
                'moment',
                'dblAnalyticsProvider',
                'translateFilter',
                'edxAssignmentTitleTranslateFilter',
                'edxAssignmentSubTitleFilter',
                AssignedLessonItemController]
        };
    });

    function AssignedLessonItemController(
      $rootScope,
      $scope,
      $assignedFocusApi,
      $cancelableResourceManager,
      $modal,
      $minutesFilter,
      $state,
      $window,
      $compareDay,
      $moment,
      $analytics,
      translateFilter,
      assignmentTitleTranslateFilter,
      assignmentSubTitleFilter
    ) {
        $scope.onCollapseClick = onCollapseClick;
        $scope.onCancelClicked = onCancelClicked;
        $scope.isNweaAssignment = isNweaAssignment;
        $scope.isLongTermAssignment = isLongTermAssignment;
        $scope.showStandardsList = showStandardsList;
        $scope.selectedColumn = selectedColumn;
        $scope.updateSorting = updateSorting;
        $scope.onViewProgressClicked = onViewProgressClicked;
        $scope.handleRowClick = handleRowClick;
        $scope.getAssignmentTitle = getAssignmentTitle;
        $scope.getAssignmentSubTitle = getAssignmentSubTitle;

        $scope.DBL_STANDARD_ID = 2;

        $scope.sort = {
            column: 'first_name',
            descending: false
        };
        $scope.head = {
            first_name: { field: "first_name" },
            last_name: { field: "last_name" },
            lessons_completed: { field: "assignment_status" },
            minutes_spent: { field: "time_spent" },
            proficiency: { field: "lessons_passed" },
            try_lesson: { field: "" }
        };

        var m_start_date = $moment($scope.assignedLessonData.start_date);
        var m_end_date = $moment($scope.assignedLessonData.end_date);
        $scope.duration = m_end_date.diff(m_start_date, 'weeks');

        _.each($scope.assignedLessonData.students, function (student) {
            // History status fields
            student.time_spent_mins = $minutesFilter(student.time_spent, true);
            student.tutorial_time_spent_mins = $minutesFilter(student.tutorial_time_spent, true);

            student.lesson_class = $assignedFocusApi.determineLessonClass(student.student_assignment_histories);
            student.lesson_goal_name = $assignedFocusApi.validateLessonGoalName($scope.assignedLessonData.lesson_goal_name);

            student.show_duration = student.time_spent > 0 || $scope.assignedLessonData.status !== 'ACTIVE';

            student.collapsed = true;
        });

        var today = $moment(new Date());
        var due = $moment(new Date($scope.assignedLessonData.end_date));
        var diff = due.diff(today, 'days');
        var pastDue = (diff < 0);

        $scope.correctLevel = $scope.assignedLessonData && $state.params.groupId ? $scope.assignedLessonData.classroom_id === null : $scope.assignedLessonData.classroom_id !== null;
        $scope.correctClassroom = $scope.assignedLessonData && $state.params.classroomId ? parseInt($state.params.classroomId)  === $scope.assignedLessonData.classroom_id : false;

        // Default all current assignments and not past-due-closed assignments
        if ($scope.assignedLessonData.latest || !pastDue) {
            $scope.isCollapsed = false;
        }
        else {
            $scope.isCollapsed = true;
        }

        $scope.$watch('assignedLessonData', function (lessonData) {
            if ($scope.assignedLessonData) {
                lessonData.assessment = $assignedFocusApi.thirdPartyTitle(lessonData);
                lessonData.isLongTerm = $assignedFocusApi.isLongTermAssignment(lessonData);
                lessonData.isNwea = $assignedFocusApi.isNweaAssignment(lessonData);
                if (lessonData.isNwea) {
                    delete $scope.head.oprogress;
                }
            }
        });

        function onCollapseClick() {
            $scope.isCollapsed = !$scope.isCollapsed;
        }

        function cancelAssignment() {
            var cancelled = {};
            cancelled.assignment_id = $scope.assignedLessonData.assignment_id;
            cancelled.lessons_assigned = $scope.assignedLessonData.lessons_assigned;
            cancelled.start_date = $scope.assignedLessonData.start_date;

            $analytics.eventTrack('Assignment Canceled', {
                category: 'Assign Focus',
                label: 'classroom'
            });

            $assignedFocusApi.cancelClassroomLesson(cancelled, function () {
                // success
                $scope.assignedLessonData.status = 'CANCELLED';
                $scope.$emit('assignmentCanceled');
            }, function () {
                // error
                console.warn('There was an error with cancelling your assignment');
            });
        }

        function onCancelClicked() {
            verify();
        }

        function verify() {
            var modal = $modal.open({
                templateUrl: 'resources/core/partials/verify-cancel-assignment.html',
                windowClass: 'common-modal verify-modal',
                controller: 'VerifyCancelAssignmentModalController',
                resolve: {
                    lessonData: function () {
                        return $scope.assignedLessonData;
                    }
                }
            });

            // Handle the modal response from the user
            modal.result.then(function (assignment) {
                // Cancel
                cancelAssignment();
            }, function () {
                // Don't Cancel

            });
        }

        function isNweaAssignment(assignment) {
            return assignment.focusData && assignment.focusData.category === 'NWEA';
        }

        function isLongTermAssignment(assignment) {
            return $assignedFocusApi.isLongTermAssignment(assignment);
        }

        function showStandardsList(lessonData) {
            return lessonData.focus_type !== 'STANDARD' && lessonData.standards && !$assignedFocusApi.thirdPartyTitle(lessonData);
        }

        function selectedColumn(column) {
            return column === $scope.sort.column && 'sort-' + $scope.sort.descending;
        }

        function updateSorting(column) {
            var sort = $scope.sort;
            if (sort.column === column) {
                sort.descending = !sort.descending;
            } else {
                sort.column = column;
                sort.descending = false;
            }
        }

        function onViewProgressClicked(assignment, student) {
            $scope.$emit('viewProgressClick', assignment, student.user_id);
        }

        function handleRowClick(student_id) {
            var item = {};
            item.type = 'student';
            item.id = student_id;
            var override = {pane: 'overview'};

            $scope.$emit('route', item, override);
        }

        function getAssignmentTitle(lessonData) {
            return assignmentTitleTranslateFilter(lessonData);
        }

        function getAssignmentSubTitle(lessonData) {
            var subTitle = assignmentSubTitleFilter(lessonData);
            return translateFilter('curriculumData.' + subTitle, {defaultValue: subTitle});
        }

        $scope.getNumberOfWeeksText = function (duration) {
            return translateFilter('assignments.nWeeks', { count: duration });
        };

        $scope.getDisplayedAssignmentStatus = function(status) {
            return translateFilter('assignments.statuses.' + status, { defaultValue: status });
        };
        $scope.getTooltipText = function() {
          if (!$scope.correctLevel) {
            if( !$state.params.groupId) {
              return translateFilter('assignments.cannotCancelAssignedToGroup');
            } else {
              return translateFilter('assignments.cannotCancelAssignedToClassroom');
            }
          } else if( !$scope.correctClassroom) {
            return translateFilter('assignments.cannotCancelAssignedToDifferentClassroom');
          }
          return null;
        };
    }
})();
